import React, { useContext, useEffect, useRef } from "react";
import CheckoutContext from "../contexts/CheckoutContext";
import { useNavigate } from "react-router-dom";
import ProductsResume from "../components/ProductsResume";
import DateResume from "../components/DateResume";
import ClientDataResume from "../components/ClientDataResume";
import DeliveryDirectionResume from "../components/DeliveryDirectionResume";
import SellerForm from "../components/SellerForm";
import MainTitle from "../components/MainTitle";

function SellerSelect() {

    const selectSellerRef = useRef(null);
    const navigate = useNavigate();

    const { items, deliveryDate, deliveryDirection, clientData } = useContext(CheckoutContext);

    useEffect(() => {
        if (items.length === 0 || !clientData.name || !clientData.lastName || !clientData.phoneNumber || !clientData.email || deliveryDate.length !== 4 || Object.keys(deliveryDirection).length === 0) {
            navigate("/");
        }
        if (selectSellerRef.current) {
            selectSellerRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, []);

    return (
        <div className="min-h-screen bg-[#f7f4ef]">

            {/* Header */}
            <MainTitle />

            {/* Resúmenes */}
            <div className="mt-4 flex flex-col gap-3">
                <ProductsResume items={items} />
                <DateResume deliveryDate={deliveryDate} />
                <DeliveryDirectionResume deliveryDirection={deliveryDirection} />
                <ClientDataResume clientData={clientData} />
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 my-4">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">vendedor</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* Formulario de vendedor */}
            <div ref={selectSellerRef} className="pb-8">
                <SellerForm />
            </div>
        </div>
    );
}

export default SellerSelect;
